import {
    FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_START,
    FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_SUCCESS,
    FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    ecgRecordings: {},
    ecgRecordingsFetching: false,
    ecgRecordingsFetchFail: false
};

// ======= Fetching Handlers =======
const fetchEcgRecordingsFetching = (state, action) => {
    return {
        ecgRecordings: {
            ...state.ecgRecordings
        },
        ecgRecordingsFetching: true,
        ecgRecordingsFetchFail: false
    };
};

const fetchEcgRecordingsSuccess = (state, action) => {
    return {
        ecgRecordings: {
            ...state.ecgRecordings,
            ecgRecordings: action.data
        },
        ecgRecordingsFetching: false,
        ecgRecordingsFetchFail: false
    };
};

const fetchEcgRecordingsFail = (state, action) => {
    return {
        ecgRecordings: {
            ...state.ecgRecordings
        },
        ecgRecordingsFetching: false,
        ecgRecordingsFetchFail: true
    };
};

// ======= Selectors =======
export const getEcgRecordings = (state) => {
    return state.ecgRecordings.ecgRecordings ? state.ecgRecordings.ecgRecordings : [];
};

export const isEcgRecordingsFetching = (state) => {
    return state.ecgRecordings.ecgRecordingsFetching;
};

export const didEcgRecordingsFetchFail = (state) => {
    return state.ecgRecordings.ecgRecordingsFetchFail;
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_START]: fetchEcgRecordingsFetching,
    [FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_SUCCESS]: fetchEcgRecordingsSuccess,
    [FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_FAIL]: fetchEcgRecordingsFail
};

// ======= Default Action =======
export default function ecgRecordings(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
